import { TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import deepEqual from "fast-deep-equal";
import RoundedTable from "@entrilia/shared/components/RoundedTable";
import type { ObjectFieldValues } from "../../../../../../api/types/objectTypes";
import type {
  ObjectSelectConfiguration,
  WorkflowActivityEditConfiguration,
} from "../../../../../../api/types/workflowTypes";
import type { FieldState } from "./changeSetEditState";
import ChangeSetInlineEditTableRow from "./ChangeSetInlineEditTableRow";
import type { ObjectSelectOptions } from "./objectSelectOptionsHelper";

interface Props {
  fields: FieldState[];
  originalValues: ReadonlyMap<string, unknown>;
  editConfiguration?: WorkflowActivityEditConfiguration;
  objectSelectOptions: ObjectSelectOptions;
  onFieldChange: (fieldName: string, value: unknown) => void;
  onObjectChange: (configuration: ObjectSelectConfiguration, selectedObject: ObjectFieldValues | null) => void;
}

const ChangeSetInlineEditTable = ({
  fields,
  originalValues,
  editConfiguration,
  objectSelectOptions,
  onFieldChange,
  onObjectChange,
}: Props) => {
  return (
    <RoundedTable>
      <TableHead>
        <TableRow>
          <TableCell>Field</TableCell>
          <TableCell>Value</TableCell>
          <TableCell>Source</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {fields.map((field) => (
          <ChangeSetInlineEditTableRow
            key={field.name}
            field={field}
            editConfiguration={editConfiguration}
            isChangedFromOriginal={!deepEqual(field.newValue ?? undefined, originalValues.get(field.name) ?? undefined)}
            objectSelectOptions={objectSelectOptions}
            onFieldChange={onFieldChange}
            onObjectChange={onObjectChange}
          />
        ))}
      </TableBody>
    </RoundedTable>
  );
};

export default ChangeSetInlineEditTable;
